export default __webpack_public_path__ + "static/media/formWorkflows.3537adab.png";